import Banner from "./Banner";

let Contact = () => {
    return(
        <div id = "textContainer">
            <div id = "contactContainer">

            <h1>Kontakt</h1>
            <hr />
            <Banner />
            <hr /> <br />
            <h4>Koordynator Projektu: Anna Śliwa</h4>

            <p>ZESPÓŁ SZKÓŁ INFORMATYCZNYCH im. gen. Józefa Hauke Bosaka<br />
            ul. Warszawska 96, 25 - 401 Kielce<br />
            tel: 41 367 67 90 fax: 41 367 69 33<br />
            NIP: 657-17-48-539 email: <a href="mailto:szkola@zsi.kielce.pl">szkola@zsi.kielce.pl</a></p>
            
            <hr className = "customSeparator" />
            
            <p><h3>Obsługa strony</h3>
            Artur Orliński <a href="mailto:orlinskia@zsi.kielce.pl">orlinskia@zsi.kielce.pl</a></p>
            
            <hr className = "customSeparator" />
            
            <p><h3>Autorzy strony</h3>
            <a href = "https://www.linkedin.com/in/artur-orli%C5%84ski-80823226a/" target="_blank">Artur Orliński</a> <br />
            <a href = "https://www.linkedin.com/in/klaudia-strzeszkowska/" target = "_blank">Klaudia Strzeszkowska</a> <br />
            Julia Bydłosz <br />
            </p> 
            
            <hr />
            <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2517.2087668843933!2d20.63857071106677!3d50.88284635601984!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47178965188b478b%3A0x7f8057b848697308!2sZespół%20Szkół%20Informatycznych%20im.%20gen.%20Józefa%20Hauke-Bosaka%20w%20Kielcach!5e0!3m2!1spl!2spl!4v1696528024209!5m2!1spl!2spl" width="100%" height="400" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade" />
            </div>
        
        </div>
    )
}

export default Contact;